import { render, staticRenderFns } from "./BaseGroup.vue?vue&type=template&id=e87aebb2&scoped=true"
import script from "./BaseGroup.vue?vue&type=script&lang=js"
export * from "./BaseGroup.vue?vue&type=script&lang=js"
import style0 from "./BaseGroup.vue?vue&type=style&index=0&id=e87aebb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87aebb2",
  null
  
)

export default component.exports